<template>
  <span :title="Object.entries($ncsCsvElementFields(document, text, elements))
                     .map(([k, v]) => `${k}: ${v}`)
                     .join('\n')" class="fields">
    <span class="title">
      {{$ncsCsvElementFields(document, text, elements)[$t('result.context.header.document.identificador')]}}
      ({{shortDocumentType}})
    </span>
    <span class="date">
      <span v-for="part in $documentDate(document)">{{part}}&nbsp;</span>
    </span>
  </span>
</template>
<script>
  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      shortDocumentType() {
        if (this.document.tipo_rexistro === 'Edición principal') {
          return 'p'
        } else if (this.document.tipo_rexistro === 'Edición única') {
          return 'u'
        } else {
          return 's'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .fields>*:not(:last-child) {
    margin-right: 15px;
  }
</style>
